//TODO move to fork https://github.com/kalex375/vue-json-editor
import JsonEditor from './components/json-editor.vue';

export default JsonEditor;
